"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var dataSources;
        (function (dataSources) {
            var createOrEdit;
            (function (createOrEdit) {
                function init() {
                    addEvents();
                }
                createOrEdit.init = init;
                function addEvents() {
                    $('.interaction').change(function () {
                        const val = $(this).find('option:selected').val();
                        const dataSourceInteractTarget = $('#DataSource_AppConfig_InteractTarget');
                        if (val === 'OpenScreen')
                            $(dataSourceInteractTarget).closest('.group-interact-target').removeClass('d-none');
                        else
                            $(dataSourceInteractTarget).closest('.group-interact-target').removeClass('d-none').addClass('d-none');
                        if (val === 'None' || val === 'ForceSync' || val === 'RefreshScreen')
                            $('.group-interact-column').removeClass('d-none').addClass('d-none');
                        else
                            $('.group-interact-column').removeClass('d-none');
                    });
                    $('.sorttype').change(function () {
                        const val = $(this).find('option:selected').val();
                        const target = $('.group-sortby-column');
                        if (val !== 'None')
                            $(target).removeClass('d-none');
                        else
                            $(target).removeClass('d-none').addClass('d-none');
                    });
                    $('.sorttype').trigger('change');
                }
            })(createOrEdit = dataSources.createOrEdit || (dataSources.createOrEdit = {}));
        })(dataSources = views.dataSources || (views.dataSources = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
